"use strict";
// Shared DTOs for the Site Power Orchestrator.
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseProfilesEqual = void 0;
function responseProfilesEqual(a, b) {
    return ((a.maxBatterySoc ?? null) === (b.maxBatterySoc ?? null) &&
        (a.gridLimit ?? null) === (b.gridLimit ?? null) &&
        (a.gridUseFirstAboveTargetSoc ?? null) ===
            (b.gridUseFirstAboveTargetSoc ?? null) &&
        (a.gridUseFirstBelowTargetSoc ?? null) ===
            (b.gridUseFirstBelowTargetSoc ?? null) &&
        !!a.rechargeToTarget === !!b.rechargeToTarget &&
        (a.comment ?? null) === (b.comment ?? null));
}
exports.responseProfilesEqual = responseProfilesEqual;
